





























import { ElTable } from "element-ui/types/table";
import { IDateCalculateItem, IDateCalculateObject, instanceOfIDateCalculateNumber } from "../../../../../../../documaker/domain/format/objects";
import { Component, Emit, Mixins, Prop, Watch } from "vue-property-decorator";
import { StandardOption } from "../../../../../../../base/components/system/selectors/mixins";
import { OptionDropDownSelector } from "../../../../../../../base/components/system";

@Component({
  components: {
    OptionDropDownSelector,
  },
})
export default class DateCalculateSelector extends Mixins() {
  @Prop({ default: false })
  shouldShowIndex: boolean;

  @Prop({ default: false })
  shouldShowOperation: boolean;

  @Prop({ default: () => [] as IDateCalculateItem[] })
  items: IDateCalculateItem[];

  $refs!: {
    table: ElTable,
  };

  get operatorOption(): StandardOption<string>[] {
    const options = [] as StandardOption<string>[];
    return options.concat(new StandardOption<string>("+", "1"))
      .concat(new StandardOption<string>("-", "2"));
  }

  toName(row: IDateCalculateItem): string {
    return instanceOfIDateCalculateNumber(row.reference) ? "固定日数" : row.reference.name;
  }

  toKindName(row: IDateCalculateItem): string {
    switch ((row.reference as IDateCalculateObject).type) {
      case "calculate": return "期間日数";
      default: return "テキスト";
    }
  }

  @Watch("items")
  onItemsUpdated(newValue: IDateCalculateItem[], oldValue: IDateCalculateItem[]) {
    // element-uiのテーブルにスクロールバーが表示される際、ヘッダがずれる問題に対応するため、dataプロパティ更新時に遅延でdoLayoutを呼び出す
    this.$nextTick(() => this.$doWhenValid(t => t.doLayout(), this.$refs.table));
  }

  @Emit()
  selectionChange(value: IDateCalculateItem[]): void {}
}
